var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"color-display d-inline-flex flex-row"},[_c('span',{staticClass:"color-square mr-4",style:({'background-color': _vm.value})}),_vm._v(" "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }